import { Component } from "@angular/core";
import { OffreCommerciale } from "./model/offreCommerciale";
import { OffrecommercialeService } from "./offrecommerciale.service";
import { TranslateService } from "@ngx-translate/core";
import { OffreCommercialeLight } from "./model/offreCommercialeLight";
import { DetailOffreCommercialForm } from "./model/form/detailOffreCommercialForm";
import { RechercheOffresCommercialesFormNom } from "./model/form/rechercheOffreCommercialFormNom";

@Component({
  selector: "detail-offre",
  templateUrl: "./detailoffrecommerciale.component.html",
  styleUrls: ["./detailoffrecommerciale.component.scss"]
})
export class DetailOffreCommercialeComponent {
  /* constantes */
  OPEN: string = "open";
  EMPTY_TOKEN = "";
  /**/
  showDetail: string = this.EMPTY_TOKEN;
  detailOffre: OffreCommerciale = new OffreCommerciale(
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  );
  errorMessage: string;
  searchForm: RechercheOffresCommercialesFormNom = new RechercheOffresCommercialesFormNom(
    null,
    null,
    null,
    null,
    null,
    null,
    null
  );

  /*Variable d'internationalisation*/
  LRM;
  constructor(
    public offreService: OffrecommercialeService,
    public translate: TranslateService
  ) {
    this.translate.get("LRM").subscribe(res => {
      this.LRM = res;
    });
  }

  showDetailOffre(
    offre: OffreCommercialeLight,
    searchForm: RechercheOffresCommercialesFormNom
  ) {
    this.searchForm = searchForm;
    let form: DetailOffreCommercialForm = new DetailOffreCommercialForm(
      offre.id,
      offre.famille,
      this.translate.currentLang
    );
    this.offreService.getDetailOffrecommerciale(form).subscribe(
      data => {
        this.detailOffre = data;
        let langue =this.translate.currentLang ;
       if(this.detailOffre.familleTouchee !="Direct"){
        if (langue =="en")
        {
          this.detailOffre.familleTouchee="Transshipment";
        }
      }
        this.showDetail = this.OPEN;
      },
      error => (this.errorMessage = <any>error)
    );
  }

  closeDetail() {
    this.showDetail = this.EMPTY_TOKEN;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/offrecommerciale/detailoffrecommerciale.component.ts